import { EntryKind } from 'shared/domains/apollo/generated/types';
export function getDocumentEntries(entries) {
    const isDocument = (entry) => entry.kind === EntryKind.Document;
    const fileSystemDocuments = (entries === null || entries === void 0 ? void 0 : entries.filter(isDocument)) || [];
    return fileSystemDocuments;
}
